import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { Tooltip, TooltipContent } from '@/components/ui/tooltip';

import { toast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';
import { TooltipTrigger } from '@radix-ui/react-tooltip';
import { useNavigate } from '@tanstack/react-router';
import dayjs from 'dayjs';
import { ChevronRight, Circle, CircleCheck } from 'lucide-react';
import { useEffect, useState } from 'react';
import TradeInAppraisalFavoriteUnfavorite from './favorite-unfavorite/trade-in-appraisal-favorite-unfavorite';
import TradeMenu from './trade-menu';

const LastSaved = () => {
  // const { deal } = useDealContext();
  // const lastSaved = dayjs(deal?.last_updated);
  // const wasSavedRecently = lastSaved.isAfter(dayjs().subtract(5, 'seconds'));
  const wasSavedRecently = false;

  // TECH DEBT: make a hook called useTick
  const [, setTime] = useState(dayjs());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(dayjs());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          onClick={() => {
            toast({
              title: 'Last saved (Not Implemented)',
              description: 'Request for this feature over slack.',
            });
          }}
        >
          {wasSavedRecently ? (
            <CircleCheck
              className={cn('h-3.5 w-3.5 cursor-pointer text-green-500', {})}
            />
          ) : (
            <Circle className={cn('h-3.5 w-3.5 cursor-pointer', {})} />
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        {/* <p>Last saved {lastSaved.toLocaleString()}</p> */}
        <p>Last saved (Not Implemented)</p>
      </TooltipContent>
    </Tooltip>
  );
};

const useGoToTradeInAppraisal = () => {
  const goToTradeInAppraisal = ({ tradeShortId }: { tradeShortId: string }) => {
    const navigate = useNavigate();
    navigate({
      to: `/${PAGE_ROUTES.TRADE_IN}/${tradeShortId}`,
    });
  };

  return { goToTradeInAppraisal };
};

const NonMobileHeader = ({ tradeShortId }: { tradeShortId: string }) => {
  const navigate = useNavigate();

  const { goToTradeInAppraisal } = useGoToTradeInAppraisal();

  return (
    <div className="flex w-full h-10 shrink-0 items-center justify-between px-8 py-2 dark:bg-dark">
      <div className="flex flex-row items-center gap-3">
        <div className="flex flex-row items-center gap-2">
          <div
            className="cursor-pointer text-gray-600 dark:text-white whitespace-nowrap"
            onClick={() => {
              navigate({ to: `/${PAGE_ROUTES.TRADES}` });
            }}
          >
            Trades
          </div>
          <ChevronRight className={cn('h-3.5 w-3.5', {})} />
          <div
            className="text-gray-600 cursor-pointer dark:text-white whitespace-nowrap text-nowrap"
            onClick={() => {
              goToTradeInAppraisal({
                tradeShortId,
              });
            }}
          >
            {tradeShortId}
          </div>
        </div>
        <TradeMenu />
        <TradeInAppraisalFavoriteUnfavorite />
      </div>
      <div className="flex flex-row items-center gap-3">
        <LastSaved />
      </div>
    </div>
  );
};

export default NonMobileHeader;
